var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalRecirculationStaged = function SvgDAhuSignalRecirculationStaged(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 105,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,95c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S301.5,95,307,95 M307,94c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S313.1,94,307,94L307,94z",
    fill: "#1C9D5B"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "305.5,109 305.5,105.1 309.5,105.1 309.5,101.2 312.9,101.2 312.9,100.2 308.5,100.2 308.5,104.1 304.5,104.1 304.5,108 301.6,108 301.6,98.7 300.6,98.7 300.6,111 312.9,111 312.9,110 301.6,110 301.6,109"
  })))));
};
export default SvgDAhuSignalRecirculationStaged;